import type { CliE2eeRuntime } from '../../../../lib/e2ee/index.js';
import { formatCliE2eeDecryptError } from '../../../../lib/e2ee/decrypt-stored-e2ee-content.js';
import { formatParentTranscriptText } from './format-parent-transcript-text.js';
import { fetchInternalApiJson } from './internal-api.js';
import type { CloudFetchParams, TurnTranscriptJson } from './types.js';

export async function fetchCloudParentTurnTranscript(
  params: CloudFetchParams & { childSessionId: string; turnId: string; e2ee?: CliE2eeRuntime },
): Promise<{ ok: true; text: string } | { ok: false; error: string }> {
  const fetched = await fetchInternalApiJson<TurnTranscriptJson>({
    ...params,
    path: `/internal/sessions/${encodeURIComponent(params.childSessionId)}/parent/turns/${encodeURIComponent(params.turnId)}/transcript`,
    errorLabel: 'Transcript fetch failed',
  });
  if (!fetched.ok) return fetched;
  const rows = Array.isArray(fetched.data.transcript) ? fetched.data.transcript : [];
  try {
    return { ok: true, text: formatParentTranscriptText(rows, params.e2ee) };
  } catch (error) {
    return { ok: false, error: formatCliE2eeDecryptError(error, params.e2ee) };
  }
}
